var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiRrAngleSmallDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7923 7.20618C14.7259 7.14085 14.6469 7.089 14.5599 7.05361C14.4729 7.01822 14.3795 7 14.2852 7C14.1909 7 14.0976 7.01822 14.0106 7.05361C13.9235 7.089 13.8445 7.14085 13.7781 7.20618L10.5071 10.3986C10.4407 10.464 10.3617 10.5158 10.2747 10.5512C10.1876 10.5866 10.0943 10.6048 10 10.6048C9.90572 10.6048 9.81237 10.5866 9.72533 10.5512C9.6383 10.5158 9.55931 10.464 9.49291 10.3986L6.22186 7.20618C6.15546 7.14085 6.07647 7.089 5.98944 7.05361C5.9024 7.01822 5.80905 7 5.71477 7C5.62049 7 5.52714 7.01822 5.4401 7.05361C5.35307 7.089 5.27408 7.14085 5.20769 7.20618C5.07466 7.33678 5 7.51345 5 7.6976C5 7.88175 5.07466 8.05841 5.20769 8.18901L8.48589 11.3884C8.88763 11.78 9.4322 12 10 12C10.5678 12 11.1124 11.78 11.5141 11.3884L14.7923 8.18901C14.9253 8.05841 15 7.88175 15 7.6976C15 7.51345 14.9253 7.33678 14.7923 7.20618Z",
    fill: "#565A6D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiRrAngleSmallDown);
export default __webpack_public_path__ + "static/media/fi-rr-angle-small-down.a723786572e48627789d2760dbe14680.svg";
export { ForwardRef as ReactComponent };